import React from 'react';
import reqwest from 'reqwest';
import swal from 'sweetalert';

import settings from '../../../../../settings';

import RightSide from '../../../../components/FormArea/RightSide';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import ContentBox from '../../../../components/FormArea/ContentBox';
import Input from '../../../../components/Inputs/Input';
import { faTimes, faSave } from '@fortawesome/pro-solid-svg-icons';
import DataContainer from '../../../../logic/dataContainer';

class SectionNew extends React.Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(/\/new$/, '');

    this.state = {
      loading: false,
      protocols: [],
    };

    this.dataContainer = new DataContainer();
    this.dataContainer.add('PermissionEntry', {
      Name: '',
      Bemerkung: '',
    });
  }

  save = () => {
    const Section = this.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.permissions.AddSection,
      data: {
        Token: localStorage.getItem('token'),
        Section,
      },
    }).then(saveResult => {
      saveResult = JSON.parse(saveResult);

      if (saveResult[0].Params.SaveResult === 'Saved') {
        swal({
          title: 'Erfolg!',
          text: 'Die Anwendungssektion wurde erfolgreich angelegt.',
          icon: 'success',
        });
        this.props.history.replace(this.parentRoute);
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Neue Sektion'>
            <Input
              type='text'
              label='Name:'
              validator={[]}
              onChange={value => {
                this.dataContainer.set('PermissionEntry', 'Name')(value);
              }}
              defaultValue={this.dataContainer.get('PermissionEntry', 'Name')}
              name='Name'
            />
            <Input
              type='text'
              label='Bemerkung:'
              validator={[]}
              onChange={value => {
                this.dataContainer.set('PermissionEntry', 'Bemerkung')(value);
              }}
              defaultValue={this.dataContainer.get('PermissionEntry', 'Bemerkung')}
              name='Bemerkung'
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faTimes} to={this.parentRoute}>
            Abbrechen
          </Button>
          <Button big type='primary' icon={faSave} onClick={this.save}>
            Speichern
          </Button>
        </RightSide>
      </>
    );
  }
}

export default SectionNew;
